import Container from "@/components/common/Container";
const Title = ({
  mainTitle,
  SubTitle,
  Description,
  className,
  customClass,
  textBlack,
}) => (
  <Container large>
    {mainTitle ? (
      <h1 className="text-4xl md:text-5xl xl:text-8xl font-medium text-white pb-10 md:pb-6 xl:pb-10 text-center md:text-start">
        <span className="font-jost">{mainTitle}</span>
      </h1>
    ) : (
      <h2
        className={`text-2xl xl:text-5xl font-medium ${
          textBlack ? "text-black" : "text-white"
        } ${customClass}`}
      >
        <span className="font-jost">{SubTitle}</span>
      </h2>
    )}
    {Description && (
      <p
        className={`text-lg md:text-base xl:text-lg font-normal ${
          textBlack ? "text-black" : "text-white"
        } text-justify ${className}`}
      >
        <span
          dangerouslySetInnerHTML={{ __html: Description }}
          className="font-jost"
        ></span>
      </p>
    )}
  </Container>
);
export default Title;
